import AuthLoading from "@components/loadings/auth";
import { useAuth } from "@contexts/auth";
import { FC } from "react";
import AuthRoutes from "./auth";
import DashboardRoutes from "./dashboard";

interface Props {}

const Routes: FC<Props> = () => {
    const { values } = useAuth();

    return (
        <>
            {values.isLogin === "TRUE" && <DashboardRoutes />}

            {values.isLogin === "FALSE" && <AuthRoutes />}

            {values.isLogin === "PENDING" && <AuthLoading />}
        </>
    );
};

export default Routes;
